import type {
  RecommendationsExplainerInput,
  RecommendationsExplainerSurface,
} from 'bundles/recommendations-common/types';

/** Returns the string when it is non-empty; otherwise undefined. */
export const nonEmptyString = (value: unknown): string | undefined =>
  typeof value === 'string' && value.length > 0 ? value : undefined;

export type ExplainerHostContext = Pick<
  RecommendationsExplainerInput,
  'surface' | 'label' | 'carouselName' | 'filterSection'
>;

/**
 * Client-only explainer UI context (not used for Apollo cache identity).
 * Spreads only defined fields so hosts can omit unused props cleanly.
 */
export const pickExplainerHostContext = ({
  surface,
  label,
  carouselName,
  filterSection,
}: {
  surface?: RecommendationsExplainerSurface;
  label?: string | null;
  carouselName?: string | null;
  filterSection?: number;
}): ExplainerHostContext => {
  const resolvedLabel = nonEmptyString(label);
  const resolvedCarouselName = nonEmptyString(carouselName);
  return {
    ...(surface !== undefined ? { surface } : {}),
    ...(resolvedLabel !== undefined ? { label: resolvedLabel } : {}),
    ...(resolvedCarouselName !== undefined ? { carouselName: resolvedCarouselName } : {}),
    ...(filterSection !== undefined ? { filterSection } : {}),
  };
};
